import { useNavigate, useSearchParams } from "react-router-dom";
import { LoggedInLayoutSelector } from "../../Layouts/LoggedInLayoutSelector";
import { VerifyUser } from "./VerifyUser";
import { useCallback, useEffect, useState } from "react";
import { SessionTimesPretty } from "../../components/SessionTimesPretty";
import { Combo } from "../../components/Common/Combo";
import { ItemPair } from "../../firestore/Types/UI/ItemPair";
import { getTutorProfile } from "../../firestore/Functions/tutorProfileFunctions";
import { SubjectView } from "../../firestore/Types/SubjectSchema";
import { BookNewSession, GetAllNewBookingsForTutorStudent } from "../../firestore/Functions/bookingFunctions";
import { useUtility } from "../../contexts/auth/UtilityContext";
import { AvailabilitiesCollection, AvailabilitiesIsAny, AvailabitiesBinary, convertScheduleToAvailbilityBinary, getEmptyAvailabilityBinary, getUnselectedAvailabilityIsAny } from "../../Utils/TimeSlotUtils";
import { CalendarSelector } from "../../components/Calendar/CalendarSelector";
import { TutorProfileView, TutorScheduleNoTimeZone } from "../../firestore/Types/TutorProfileSchema";
import { NewBookingView } from "../../firestore/Types/NewBookingSchema";
import { useAuth } from "../../contexts/auth/AppAuthContext";
import { ErrorMessage, ValidationObject } from "../../firestore/Types/UI/ValidationObject";
import { WeekSessionPickerMobile } from "../../components/Calendar/WeekSessionPickerMobile";
import { Textbox } from "../../components/Common/Textbox";
import { Button } from "../../components/Common/Button";

export function BookSession() {
    const [searchParams] = useSearchParams();
    const [useAvailabilities, setAvailabilities] = useState<AvailabitiesBinary>();
    const [useAvailabilitiesIsAny, setAvailabitiesIsAny] = useState<AvailabilitiesIsAny>();
    const [tutorAvailabilities, setTutorAvailabilities] = useState<AvailabitiesBinary>();
    const [availabitiesCollection, setAvailabitiesCollection] = useState<AvailabilitiesCollection>();

    const [pendingBookings, setPendingBookings] = useState([] as NewBookingView[]);
    const [tutorProfile, setTutorProfile] = useState({} as TutorProfileView);
    const [TutorTimeZone, setTutorTimeZone] = useState("");
    const [subjectId, setSubjectId] = useState("");
    const [duration, setDuration] = useState("2");
    const [isRecurring, setIsRecurring] = useState(true);
    const { currentUser } = useAuth();


    const navigate = useNavigate();
    const tutorId = searchParams.get("tutorId");
    const hourItems = [{ Text: "1 Hour", Value: "2" }, { Text: "1.5 Hour", Value: "3" }, { Text: "2 Hour", Value: "4" }, { Text: "2.5 Hour", Value: "5" }, { Text: "3 Hour", Value: "6" }] as ItemPair[];
    const occuranceItems = [{ Text: "Weekly", Value: "weekly" }, { Text: "One Time", Value: "adhoc" },] as ItemPair[];
    const [subjectsItems, setSubjectItems] = useState<ItemPair[]>([]);
    const { subjects: subjectNames, setNewToast } = useUtility();

    const setupPage = useCallback(async (tutorId: string | null) => {
        if (tutorId === null) {
            navigate("/tutors");
            return;
        }

        const newProfile = await getTutorProfile(tutorId).catch((error) => {
            setNewToast({ title: "Error", message: error.message, toastType: "error" });
            return undefined;
        });

        if (newProfile === undefined) {
            navigate("/tutors");
            return;
        }

        const currentWeekSchedule = newProfile.Schedule;
        setTutorProfile(newProfile);
        const tutorSubs = newProfile.Subjects;
        var subItems = [] as ItemPair[];
        tutorSubs.forEach((subject) => {
            subItems.push({ Text: getSubjectName(subject.SubjectID, subjectNames), Value: subject.SubjectID } as ItemPair)
        });

        const currentBookings = await GetAllNewBookingsForTutorStudent(tutorId, currentUser.uid).catch((error) => {
            setNewToast({ title: "Error", message: error.message, toastType: "error" });
            return [];
        });
        setPendingBookings(currentBookings);
        setSubjectItems(subItems);
        setTutorAvailabilities(convertScheduleToAvailbilityBinary(currentWeekSchedule ?? {} as TutorScheduleNoTimeZone));
        setAvailabilities(getEmptyAvailabilityBinary());
        setAvailabitiesIsAny(getUnselectedAvailabilityIsAny());
        setTutorTimeZone(currentWeekSchedule?.TimeZone ?? "");
    }, [navigate, setNewToast, subjectNames, currentUser.uid]);

    const getSubjectName = (subjectID: string, subjects: SubjectView[]) => {
        // Get subject name from subject ID
        for (const subject of subjects) {
            if (subject.Id === subjectID) {
                return subject.SubjectName;
            }
        }
        return "";
    }
    function validateNewBooking(): ValidationObject{
        let isValid = true;
        let foundAMatch = false;
        let errorMessage = [] as ErrorMessage[];
        let durationRequired = "1".repeat(Number(duration));
        if (useAvailabilities) {
            Object.keys(useAvailabilities).forEach((key) => {
                if (useAvailabilities[key as keyof AvailabitiesBinary].indexOf(durationRequired) >= 0){
                    foundAMatch = true;
                }
            })
        }
        if (!foundAMatch) {
            errorMessage.push({ title: "Not enough time slots selected", message: "Please pick enough time slots to be enough for the duration" } as ErrorMessage);
            isValid = false;
        }
        return { isValid: isValid, errorMessages: errorMessage };
    }
    const handleSubmit = async () => {
        var validObject = validateNewBooking();
        if (validObject.isValid) {
            const success = await BookNewSession(tutorId ?? "", subjectId, parseInt(duration), useAvailabilities ?? {} as AvailabitiesBinary, TutorTimeZone, undefined, isRecurring).catch((error) => {
                setNewToast({ title: "Error", message: error.message, toastType: "error" });
                return false;
            });
            if (success === false) {
                return;
            }
            setAvailabilities(getEmptyAvailabilityBinary());
            setAvailabitiesIsAny(getUnselectedAvailabilityIsAny());
            setCalendarValues(getEmptyAvailabilityBinary(), getUnselectedAvailabilityIsAny());
            showToastMessage("Saved!", "See your requests are in Calendar under requests!", "success");
        }
        else {
            if (validObject.errorMessages.length > 0) {
                showToastMessage(validObject.errorMessages[0].title, validObject.errorMessages[0].message, "error");

            }

        }
    }

    const setCalendarValues = (availabilities: AvailabitiesBinary, availabilitiesIsAny: AvailabilitiesIsAny) => {
        setAvailabitiesIsAny(availabilitiesIsAny);
        setAvailabilities(availabilities);
        const newAvailabitiesCollection = { ...availabitiesCollection, Binaries: availabilities, IsAny: availabilitiesIsAny };
        setAvailabitiesCollection(newAvailabitiesCollection);
    }

    useEffect(() => {
        setupPage(tutorId);
    }, [tutorId, setupPage]);

    function setOccurance(value: string): void {
        if (value.toLowerCase() === "adhoc") {
            setIsRecurring(false);
        } else {
            setIsRecurring(true);
        }
    }
    //toast functions
    const showToastMessage = (title: string, message: string, toastType: string) => {
        setNewToast({ title: title, message: message, toastType: toastType as "error" | "success" | "warning" });
    }
    return (
        <LoggedInLayoutSelector>
            <VerifyUser />
            <div className="main-bg pt-20">
                 <div className="grid lg:grid-cols-10 max-lg:grid-cols-1 gap-2 max-h-[calc(100vh-100px)]">
                    <CalendarSelector classNameCss="lg:col-span-7 flex max-h-[calc(100vh-100px)] max-lg:collapse max-lg:max-h-0  max-lg:p-0"  tutorAvailabilities={tutorAvailabilities ?? {} as AvailabitiesBinary} availabilities={useAvailabilities ?? {} as AvailabitiesBinary} availabilitiesIsAny={useAvailabilitiesIsAny ?? {} as AvailabilitiesIsAny} setCalendarValues={setCalendarValues} ></CalendarSelector>
                    <div className="section-box relative lg:col-span-3 max-lg:grid-cols-1 max-h-[calc(100vh-100px)]  max-lg: min-h-[calc(100vh-100px)]">
                        <div className="absolute-0 p-4 flex flex-col">
                            <div className="text-xl flex flex-row">
                                <h3 className="section-title pt-0">Session Booking</h3>
                            </div>
                            <div className="overflow-y-auto">
                               
                                <div className="basic-form-label">
                                    <Textbox label={"Tutor Name"} value={tutorProfile.Name} name={""} isReadonly={true }></Textbox>
                                </div>
                                <div>
                                    <Combo label="Occurance" name={"occurance"} items={occuranceItems} onUserChange={setOccurance}></Combo>
                                </div>
                                <div>
                                    {subjectsItems.length > 0 ? <Combo label="Subject" name={"subject"} items={subjectsItems} onUserChange={setSubjectId}></Combo> : <></>}
                                </div>
                                <div>
                                    <Combo label="How many hours of tutoring required:" name={"hours"} items={hourItems} onUserChange={setDuration}></Combo>
                                </div>
                                <SessionTimesPretty classNameCss="lg:grow flex flex-col max-lg:collapse  max-lg:h-0 max-lg:p-0 max-lg:m-0 overflow-y-auto" availabilitiesCollection={availabitiesCollection} currentBookings={pendingBookings} ></SessionTimesPretty>
                                <WeekSessionPickerMobile classNameCss="max-lg:grow flex flex-col lg:collapse  lg:h-0 lg:p-0 lg:m-0 overflow-y-auto" tutorAvailabilities={tutorAvailabilities ?? {} as AvailabitiesBinary} availabilities={useAvailabilities} onChange={setAvailabilities}></WeekSessionPickerMobile>
                               
                            </div>
                            <div className="grow"></div>
                            <div className="flex flex-row-reverse">
                                <Button onClick={handleSubmit}>Submit Request</Button>
                            </div>
                        </div>
                          
                    </div>

                    </div>
                   

            </div>
        </LoggedInLayoutSelector>
    )
}


